<template>
  <div class="sidebar">
    <div class="sidebar__nav">
      <router-link
        v-for="item in nav"
        :key="item.name"
        :to="item.path"
        tag="div"
        class="sidebar__nav-item"
      >
       <svg-icon
      width="20"
      height="20"
      :icon="item.icon"
    />
      {{ item.name }}</router-link>
    </div>
    <div 
      id="logo"
    >
      <svg width="30px" height="31px" viewBox="0 0 30 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="Template-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <g id="0.2-email-signature-app-generator-basic" transform="translate(-28.000000, -690.000000)" fill="#FFFFFF">            <path d="M56.6363636,690 C57.3894792,690 58,690.621382 58,691.387894 L58,719.145784 C58,719.912297 57.3894792,720.533678 56.6363636,720.533678 L29.3636364,720.533678 C28.6105208,720.533678 28,719.912297 28,719.145784 L28,691.387894 C28,690.621382 28.6105208,690 29.3636364,690 L56.6363636,690 Z M46.8784644,707.287565 C45.6350746,708.068356 44.4160506,709.581803 43.9827786,710.663342 L46.8115957,714.010574 L49.631436,711.924734 L46.8784644,707.287565 Z M50.9189269,701.147038 C44.4647317,701.889022 38.9734446,705.871521 36.0347065,711.463923 L39.9162004,714.005551 C42.2406633,709.179201 46.6801896,705.604168 52,704.537367 L50.9189269,701.147038 Z M44.7405648,696.557801 L41.2538705,696.557801 L40.7632564,702.495169 L35.0763099,701.13191 L34,704.512538 L37.9485458,706.209569 C38.7582972,705.375793 39.6633135,704.648734 40.658465,704.027459 C42.006463,703.183795 43.1829842,702.625767 45.1835465,701.927253 L44.7405648,696.557801 Z" id="Combined-Shape"></path>        </g>    </g></svg>'
    </div>
  </div>
</template>

<script>
import nav from '../db/navigation'

export default {
  name: '',

  data () {
    return {
      nav: nav.sidebar
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/variables.scss';

#logo{
  width:30px;
  height:30px;
  margin:20px auto;
  position:absolute;
  bottom:0;
  left:0;
  right:0;

}
.sidebar {
  border-right: 1px solid #ddd;
  background-color:#1B2734;
  position:relative;
  &__nav {
    &-item {
      padding: 25px 7px;
      font-size: 12px;
      text-transform: uppercase;
      cursor: pointer;
      text-align: center;
      font-family: Helvetica, Arial;
      font-size: 12px;
      color: #98A1AB;
      text-align: center;
      line-height: 18px;
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
      &.active {
        color: #fff;
        &:hover {
          color: #fff;
          svg path{
            fill:#fff;
          }
        }
      }
      &:hover {
        // background-color: #eee;
        color: #fff;
           svg path{
            fill:#fff;
          }
      }
    }
  }
}
</style>
